<mat-card class="events-list">
  <mat-card-header>
    <mat-card-title>{{ title() | translate }}</mat-card-title>

    @if (eventsList().length > 0) {
      <div class="events-list__actions">
        <button mat-icon-button type="button" [disabled]="eventsList().length <= 4">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button mat-icon-button type="button" [disabled]="eventsList().length <= 4">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    }
  </mat-card-header>
  <mat-card-content>
    @for (eventListItem of eventsList(); track eventListItem.eventId) {
      <div class="events-list__event">
        <app-new-single-event
          [eventItem]="eventListItem"
          (selectEvent)="goToEventPage(eventListItem)"
        />
      </div>
    } @empty {
      <p>{{'TICKETS.NO_TICKETS_PURCHASED' | translate}}</p>
    }
  </mat-card-content>
  <mat-card-footer>
    @for (i of pageIndices(); track i) {
      <app-dot-button
        [active]="currentPage"
        [index]="i"
        (dotClick)="handleChangePage($event)"
      />
    }
  </mat-card-footer>
</mat-card>
